import {
  FETCH_STATISTICS_REQUESTED,
  FETCH_STATISTICS_SUCCESS,
  FETCH_STATISTICS_FAILURE,
} from 'constants/actions'

const initialState = {
  isLoading: false,
  isError: false,
  data: null,
}

const reducer = (state = initialState, { type, data }) => {
  switch (type) {
    case FETCH_STATISTICS_REQUESTED:
      return { ...state, isLoading: true }
    case FETCH_STATISTICS_SUCCESS:
      return { ...state, isLoading: false, data }
    case FETCH_STATISTICS_FAILURE:
      return { ...state, isError: true, isLoading: false }
    default:
      return state
  }
}

export default reducer
